import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './BoardChatPreAtendimentoCloseModal.css';

function agentDisplayName(agent) {
  return (
    String(agent?.name || agent?.available_name || agent?.email || '').trim() ||
    `Agente ${agent?.id ?? ''}`
  );
}

function agentInitials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
}

/**
 * Ao devolver à fila com OS próprias e outros agentes já com OS na conversa,
 * pede para quem repassar as OS antes de sair.
 */
export function BoardChatReturnToQueueMenu({
  open,
  anchorRect,
  agents = [],
  osIds = [],
  busy = false,
  onClose,
  onPick,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (e.target?.closest?.('.bch-return-queue-menu')) return;
      if (e.target?.closest?.('.bch-pill--icon')) return;
      onClose?.();
    };
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    const timer = window.setTimeout(() => {
      document.addEventListener('mousedown', onDoc, true);
    }, 0);
    window.addEventListener('keydown', onKey);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('mousedown', onDoc, true);
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open || !anchorRect) return null;

  const list = Array.isArray(agents) ? agents : [];
  const ids = (Array.isArray(osIds) ? osIds : []).map((id) => String(id).trim()).filter(Boolean);
  const menuWidth = 220;
  const left = Math.min(
    Math.max(8, anchorRect.right - menuWidth),
    window.innerWidth - (menuWidth + 8)
  );
  const top = Math.min(anchorRect.bottom + 4, window.innerHeight - 8);
  const osLabel =
    ids.length === 1 ? `OS ${ids[0]}` : ids.length > 1 ? `${ids.length} OS` : 'suas OS';

  return createPortal(
    <div
      className="bch-os-chip-menu bch-return-queue-menu is-handoff"
      role="menu"
      aria-label="Repassar OS ao devolver para a fila"
      style={{ left, top, minWidth: menuWidth }}
    >
      <p className="bch-os-chip-menu-hint bch-return-queue-menu-hint">
        Repassar {osLabel} para quem?
      </p>
      <div className="bch-os-chip-handoff-list" role="group">
        {list.map((agent) => {
          const id = Number(agent?.id ?? agent?.user_id);
          const name = agentDisplayName(agent);
          return (
            <button
              key={id}
              type="button"
              role="menuitem"
              className="bch-os-chip-menu-item bch-os-chip-handoff-item"
              disabled={busy || !Number.isFinite(id)}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (!Number.isFinite(id) || busy) return;
                onPick?.(id, name);
              }}
            >
              <span className="bch-os-chip-handoff-avatar" aria-hidden>
                {agentInitials(name)}
              </span>
              <span className="bch-os-chip-handoff-name">{name}</span>
            </button>
          );
        })}
      </div>
    </div>,
    document.body
  );
}
